import { useState, useEffect } from 'react'
import AudioVisualiser from '../AudioVisualiser'

const AudioAnalyser = ({ audio }) => {
  const [audioData, setAudioData] = useState(new Uint8Array(0))
  var audioContext
  var analyzer
  var dataArray
  var source
  var rafId

  const tick = () => {
    analyzer.getByteTimeDomainData(dataArray)
    setAudioData(dataArray)
    rafId = requestAnimationFrame(tick)
  }

  useEffect(() => {
    audioContext = new (window.AudioContext || window.webkiAudioContext)()
    analyzer = audioContext.createAnalyser()
    dataArray = new Uint8Array(analyzer.frequencyBinCount)
    source = audioContext.createMediaStreamSource(audio)
    source.connect(analyzer)
    rafId = requestAnimationFrame(tick)
  }, [])

  useEffect(() => {
    return () => {
      cancelAnimationFrame(rafId)
      analyzer.disconnect()
      source.disconnect()
    }
  }, [])

  return <AudioVisualiser audio={audioData} />
}

export default AudioAnalyser
